export class Api
{

	static async query(path, data = {}, options = {})
	{
		let resultData = undefined,
			method  = options.method || 'POST',
			dataType = options.dataType || 'json'

		try {
			const result = await new Promise((resolve, reject) => {
				BX.ajax({
					url: path,
					data: data,
					method: method,
					dataType: dataType,
					onsuccess: resolve,
					onfailure: reject
				})
			})

			resultData = result
		} catch (e) {
			throw e
		}

		return resultData
	}

	static async queryModule(action, data, options = {})
	{
		let resultData = undefined

		try {
			const result = await new Promise((resolve, reject) => {
				BX.ajax
					.runAction(action, {data})
					.then(resolve, reject)
			})

			resultData = result.data
		} catch (e) {
			throw e
		}

		return resultData
	}

	static async queryComponent(componentName, action, data, options = {})
	{
		let resultData = undefined

		try {
			const result = await new Promise((resolve, reject) => {
				BX.ajax
					.runComponentAction(componentName, action, {mode: 'class', data})
					.then(resolve, reject)
			})

			resultData = result.data
		} catch (e) {
			throw e
		}

		return resultData
	}

	static getCurPageParams()
	{
		return `${window.location.pathname}${window.location.search}`
	}

	static getFormParams(formElement)
	{
		let formData = new FormData(formElement),
			data = {}

		for (const [key, value] of formData.entries()) {
			data[key] = value
		}

		return data
	}

}
